import { useContext } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import WebsiteItem from './WebsiteItem';

export default function WebsitesList() {
    const {websitesNames} = useContext(AppContext);
    
    const deployWebsites=()=>{
        return websitesNames.map((webName, inx)=>{
            if(inx < 3){
                if(inx%2===0){
                    return <WebsiteItem key={`subscription_websiteItem_inx_${inx}`} webName={webName} fade="fade-right"/>
                }
                else{
                    return <WebsiteItem key={`subscription_websiteItem_inx_${inx}`} webName={webName} fade="fade-left"/>
                }
            }
            else{
                return null;
            }
        })
    }
    return (
        <div className='subscription_websitesList'>
            <h1>דוגמאות לאתרים</h1>
            {deployWebsites()}
            {/* <div className='subscription_websitesList_more' onClick={()=>{nav("/webingo/explore")}}>תראה לי עוד...</div> */}
        </div>
    )
}
